<template>
    <div>
        <div class="flex flex-between flex-y-center">
            <el-page-header @back="goBack" title="">
                <div slot="content" class="flex flex-v-center">
                    <h2><span class="color-primary">{{ source_index + 1 }}</span> / {{ total }}</h2>
                </div>
            </el-page-header>

            <div class="flex flex-v-center">
                <i style="font-size: 30px;" class="el-icon-timer"></i>
                <h3 style="letter-spacing: 2px;margin-left: 10px;"> <span>{{ timeText }}</span></h3>
            </div>
        </div>

        <div class="game flex flex-column flex-v-center flex-h-center" style="height: 80vh;">
            <div v-if="source">
                <h3 class="center">{{ source.title }} #{{ source.no }}</h3>
            </div>

            <div v-if="source" class="margin-t">
                <h3 class="center">{{ source.words_zh }}</h3>
            </div>
            <div class="flex flex-v-center margin-lt flex-h-center" style="gap: 20px;flex-wrap: wrap;">
                <div :class="{ 'right': submitFlag && word.input == word.word, 'wrong': submitFlag && word.input != word.word }"
                    class="pointer" v-for="(word, i) in words" :key="`${source_index}_${i}`" @click="word_index = i">
                    <h3 class="center" :style="{ opacity: answerFlag ? 1 : 0 }">/{{ word.phonetic[0] }}/</h3>
                    <h1 style="height: 60px; line-height: 60px;" class="center">{{ answerFlag ? word.word : word.input
                    }}
                    </h1>
                    <div :style="{ backgroundColor: submitFlag ? (word.word == word.input ? 'right' : 'wrong') : (word_index == i ? '#e6a13c' : ($store.state.theme == 'dark' ? '#fff' : '#999')) }"
                        style="height: 2px;">
                    </div>
                </div>
            </div>

            <div class="flex flex-v-center" style="gap: 40px;margin-top: 80px;">
                <el-tooltip placement="top">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">p</el-tag> 上一题</div>
                    <i @click="prev()" class="el-icon-arrow-left color-primary pointer"
                        style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>

                <div class="flex flex-between flex-v-center" style="gap: 40px;">
                    <el-button class="flex flex-v-center pointer" @click="play(1)" type="primary" round
                        style="gap: 5px;">
                        <el-tag size="small">Ctrl</el-tag> + <el-tag size="small">w</el-tag> 播放单词
                    </el-button>

                    <el-button class="flex flex-v-center pointer" @click="play()" type="primary" round
                        style="gap: 5px;">
                        <el-tag size="small">Ctrl</el-tag> + <el-tag size="small">s</el-tag> 播放句子
                    </el-button>

                    <el-button class="flex flex-v-center pointer" @click="answerFlag = !answerFlag" type="primary" round
                        style="gap: 5px;">
                        <el-tag size="small">Ctrl</el-tag> + <el-tag size="small">a</el-tag> 查看答案
                    </el-button>

                    <el-button @click="submitFlag = true" class="flex flex-v-center" type="primary" round
                        style="gap: 5px;">
                        <el-tag size="small">Enter</el-tag> 提交
                    </el-button>

                </div>

                <el-tooltip placement="top">
                    <div slot="content"><el-tag size="small">Ctrl</el-tag> + <el-tag size="small">n</el-tag> 下一题</div>
                    <i @click="next()" class="el-icon-arrow-right color-primary pointer"
                        style="font-size: 40px;font-weight: bold;"></i>
                </el-tooltip>
            </div>

            <audio ref="audio" preload="metadata" style="display:none" :src="src">
                浏览器太老咯，请升级浏览器吧~
            </audio>

            <audio ref="type" preload="metadata" style="display:none" src="/audio/type.mp3">
                浏览器太老咯，请升级浏览器吧~
            </audio>
        </div>
    </div>
</template>
<script>

export default {
    name: 'Game',
    data() {
        return {
            words: [],
            page: 1,
            list: [],
            total: 0,
            source_index: -1,
            word_index: 0,
            source: null,
            status: 0, // 0: 未开始，1: 进行中，2: 已完成
            src: null,
            answerFlag: false,
            time: 0,
            timer: null,
            timeText: "00:00:00",
            submitFlag: false
        };
    },
    watch: {
        source_index: function (newVal) {
            if (newVal >= 0 && newVal < this.list.length) {
                this.answerFlag = false
                this.submitFlag = false
                this.$refs.audio.pause()
                this.source = this.list[this.source_index];
                this.get_words();
            }
        },
        word_index: function () {
            this.play(1)
        }
    },
    mounted() {
        this.get_list();
        document.addEventListener('keydown', this.handleKeyDown)
    },
    beforeDestroy() {
        this.stopTimer();
    },
    methods: {
        goBack() {

        },

        prev() {
            if (this.source_index > 0) this.source_index--
        },

        next() {
            if (this.source_index < this.total - 1) this.source_index++
        },

        startTimer() {
            this.timer = setInterval(() => {
                this.time++;
                // 格式化时间 00:00:00
                let h = parseInt(this.time / 3600)
                    .toString()
                    .padStart(2, "0");
                let m = parseInt((this.time % 3600) / 60)
                    .toString()
                    .padStart(2, "0");
                let s = parseInt(this.time % 60)
                    .toString()
                    .padStart(2, "0");
                this.timeText = `${h}:${m}:${s}`;
            }, 1000);
        },

        stopTimer() {
            clearInterval(this.timer);
        },

        play(flag) {
            if (flag) {
                this.src = this.$host + "/api/word/audio/" + this.words[this.word_index].word + '/1';
            } else {
                this.src = this.$host + "/api/audio/" + this.source.no + "/Andy";
            }

            this.$nextTick(() => {
                this.$refs.audio.play();
            })
        },



        handleKeyDown(e) {
            if (this.status == 0) {
                console.log(e);
                if (e.code == 'Space') {
                    this.word_index++;
                } else if (e.code == 'Backspace') {
                    if (this.words[this.word_index].input) {
                        this.words[this.word_index].input = this.words[this.word_index].input.slice(0, -1);
                    }
                    if (!this.words[this.word_index].input && this.word_index > 0) {
                        this.word_index--;
                    }
                    this.$refs.type.currentTime = 0;
                    this.$refs.type.play();
                } else if (e.code == 'Enter') {
                    this.submitFlag = true
                } else if (e.ctrlKey) {
                    if (e.key == "w") {
                        this.play(1);
                    } else if (e.key == "s") {
                        this.play();
                    } else if (e.key == "a") {
                        this.answerFlag = !this.answerFlag
                    } else if (e.key == "n") {
                        this.next()
                    } else if (e.key == "p") {
                        this.prev()
                    }
                } else if (/^[A-Za-z']$/.test(e.key)) {
                    if (!this.words[this.word_index].input) {
                        this.words[this.word_index].input = '';
                    }
                    this.words[this.word_index].input += e.key;
                    this.$refs.type.currentTime = 0;
                    this.$refs.type.play();
                }
            }
            e.preventDefault()
        },

        get_list() {
            this.$http.post('/api/source/list', { tag: 'WFD', page: this.page }).then(res => {
                this.list = res.data;
                if (this.page == 1) {
                    this.source_index = 0;
                    this.startTimer()
                }
                this.total = res.total
            });
        },
        get_words() {
            this.$http.post('/api/word/words', { content: this.source.words_en.replace(/\./g, '') }).then(data => {
                this.words = data.map(item => {
                    item.input = '';
                    return item;
                });
                this.play();
            });
        }
    },
};
</script>

<style scoped>
/* 拼写错误：波浪下划线 + 抖动动画 */
.wrong {
    animation: shake 0.1s ease-in-out;
}

/* 左右轻微抖动 */
@keyframes shake {
    0% {
        transform: translateX(0px);
    }

    25% {
        transform: translateX(-2px);
    }

    75% {
        transform: translateX(2px);
    }

    100% {
        transform: translateX(0px);
    }
}
</style>